/**
 * Point d'entrée des scripts du site IAA. Chargé en module ES différé.
 * Initialise les composants interactifs après le rendu du DOM, en
 * progressive enhancement : le site reste pleinement fonctionnel sans JS.
 */
import { initNavigation } from './navigation.js';
import { initContactForm } from './contact-form.js';
import { initReveal } from './reveal.js';
import { initCounters } from './counters.js';
import { initWebVitals } from './web-vitals.js';
import { initBackToTop } from './back-to-top.js';
import { initLegalToc } from './legal-toc.js';
import { initAnalytics } from './analytics.js';
import { initGoogleAnalytics } from './google-analytics.js';

function onReady(callback: () => void): void {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', callback, { once: true });
  } else {
    callback();
  }
}

/**
 * Repositionne la page sur l'ancre ciblée lors d'une navigation inter-pages
 * (ex. /qui-sommes-nous#references). Avec `scroll-behavior: smooth` sur la
 * racine, certains navigateurs ne réalisent pas le saut initial vers l'ancre
 * et laissent la page en haut. On force le recalage une fois la mise en page
 * stabilisée (polices, éléments en révélation).
 */
function initHashScroll(): void {
  const { hash } = window.location;
  if (hash.length < 2) {
    return;
  }

  let target: Element | null = null;
  try {
    target = document.querySelector(hash);
  } catch {
    return;
  }

  if (!target) {
    return;
  }

  requestAnimationFrame(() => {
    target!.scrollIntoView({ block: 'start' });
  });
}

onReady(() => {
  initNavigation();
  initContactForm();
  initReveal();
  initCounters();
  initWebVitals();
  initHashScroll();
  initBackToTop();
  initLegalToc();
  initGoogleAnalytics();
  initAnalytics();
});
